import React from "react";
import _ from "lodash";
import clsx from "clsx";

import withStyles from "@material-ui/core/styles/withStyles";
import Slider from "@material-ui/core/Slider";

import Tooltip from "../../../../../../../components/Tooltip";

import styles from "./styles";

const RectValueLabel = withStyles(styles)((props) => {
  const { classes, children, open, value } = props;

  return (
    <Tooltip
      open={open}
      placement="top"
      title={value}
      classes={{tooltip: classes.labelTooltip, arrow: classes.tooltipArrow, popper: classes.tooltipPopper}}
    >
      {children}
    </Tooltip>
  );
});

const SliderFormElementV2 = props => {
  const {
    classes,
    value,
    label,
    step,
    marks,
    onChange,
    min,
    max,
    style,
    disabled,
  } = props;

  const handleChange = (event, newValue) => {
    onChange(newValue);
  };

  const isUnselected = _.isNil(value);

  return (
    <Slider
      value={isUnselected ? null : value} // null - to prevent "uncontrolled component" error
      step={step}
      valueLabelDisplay={"on"}
      valueLabelFormat={label}
      ValueLabelComponent={RectValueLabel}
      marks={marks}
      min={min}
      max={max}
      disabled={disabled}
      onChange={handleChange}
      classes={{
        rail: classes.rail,
        mark: classes.mark,
        track: classes.track,
        markLabel: classes.markLabel,
        thumb: clsx(classes.thumb, isUnselected && 'hidden'),
      }}
      style={style}
    />
  );
};

export default withStyles(styles)(SliderFormElementV2);